import { render, staticRenderFns } from "./AgentDashboard.vue?vue&type=template&id=707a8195&scoped=true"
import script from "./AgentDashboard.vue?vue&type=script&lang=js"
export * from "./AgentDashboard.vue?vue&type=script&lang=js"
import style0 from "./AgentDashboard.vue?vue&type=style&index=0&id=707a8195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a8195",
  null
  
)

export default component.exports